import { SkeletonLoader } from '@civilgrid/ui/SkeletonLoader';
import isObject from 'lodash/isObject';
import { useEffect, useState } from 'react';
import { useSnapshot } from 'valtio';
import { FileUpload } from '~/pages/organization/FileUpload';
import rootStore from '~/store';

export const Logo = () => {
  const { currentOrganizationId, currentOrganization } = useSnapshot(rootStore) as typeof rootStore;
  const [isLoading, setIsLoading] = useState(true);
  const [orgLogo, setOrgLogo] = useState<{ path: string }>();

  useEffect(() => {
    if (!currentOrganization) return;
    if (!isObject(currentOrganization.logo)) {
      setIsLoading(false);
      return;
    }
    setOrgLogo(currentOrganization.logo);
    setIsLoading(false);
  }, [currentOrganization]);

  return (
    <div className="col-span-2">
      <div className="text-sm font-bold">Logo</div>
      {isLoading ? (
        <SkeletonLoader height={56} width={528} />
      ) : (
        <>
          <div className="pb-2 text-sm">Upload a company logo here. This will appear in Pothole PDF Reports.</div>
          {orgLogo && (
            <div className="pb-2">
              <img src={orgLogo.path} alt="Organization logo" className="max-h-[10rem] max-w-[30rem]" />
            </div>
          )}
          <FileUpload loadLogo={async () => await rootStore.setCurrentOrganization(currentOrganizationId)} />
        </>
      )}
    </div>
  );
};
